import { useEffect, useState } from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import Button from "../../../components/ui/button/Button";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Form from "../../../components/form/Form";
import Select from "../../../components/form/Select";
import { useLocation, useNavigate } from "react-router";

export default function InspectionItemPhotos() {
    return <div>Inspection Item Photos</div>;
}